// src/components/ProtectedRoute.js

import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import supabase from '../supabase';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isOnboarded, setIsOnboarded] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Error fetching session:', error.message);
          setUser(null);
          setIsOnboarded(null);
          setLoading(false);
          return;
        }

        const currentUser = session?.user;
        setUser(currentUser);

        if (currentUser) {
          const { data, error: profileError } = await supabase
            .from('profiles')
            .select('is_onboarded')
            .eq('user_id', currentUser.id)
            .single();

          if (profileError) {
            console.error('Error fetching profile:', profileError.message);
            setIsOnboarded(null);
          } else {
            console.log("Profile fetched:", data);
            setIsOnboarded(data?.is_onboarded ?? null);
          }
        }
      } catch (err) {
        console.error('Unexpected error:', err);
        setUser(null);
        setIsOnboarded(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();

    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (session) {
        setUser(session.user);
        supabase.auth.getSession().then(({ data, error }) => {
          if (!error && data.session) {
            supabase
              .from('profiles')
              .select('is_onboarded')
              .eq('user_id', data.session.user.id)
              .single()
              .then(({ data, error }) => {
                if (error) {
                  console.error('Error fetching profile:', error.message);
                  setIsOnboarded(null);
                } else {
                  setIsOnboarded(data?.is_onboarded ?? null);
                }
              });
          }
        });
      } else {
        setUser(null);
        setIsOnboarded(null);
      }
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  if (loading) return <p>Loading...</p>;

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (isOnboarded === false) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;
